import type { JSX } from "react";

import { usePortfolioFormat } from "../../lib/use-portfolio-format.js";
import { cn } from "../../lib/utils.js";
import { Money } from "../Money.js";

/** A P&L amount in EUR — green from zero up, red below — with an optional percentage beside it. */
export function Pl({ minor, pct }: { minor: number; pct?: number | null }): JSX.Element {
  const fmt = usePortfolioFormat();
  return (
    <span className={cn(minor < 0 ? "text-bad" : "text-good")}>
      <Money amountMinor={minor} native="EUR" sign={minor > 0 ? "+" : ""} />
      {pct != null && <span className="ml-1.5 text-sm font-medium">{fmt.pct(pct, { signed: true })}</span>}
    </span>
  );
}
